const getApiBaseUrl = () => {
  // If running on localhost, use localhost with port
  if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
    return 'http://localhost:5000';
  }
  
  // For production, use reverse proxy (no port needed)
  return `${window.location.protocol}//${window.location.hostname}`;
};

export const API_BASE_URL = getApiBaseUrl();